import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import Loading from '../shared/Loading';
import ReferredUserItem from './ReferredUserItem';
import { Redirect } from 'react-router-dom';

const ReferredUserList = () => (
  <Query query={GET_REFERRED_USERS}>
    {({ data, loading, error }) => {
      if (loading) return <Loading size="3x" />;
      if (error) return <Redirect to="/404" />;
      return (
        <div className="user-list__container">
          <h4>Invited friends</h4>

          <ul className="user-list__list">
            {data.currentUser.referrals.length ? (
              data.currentUser.referrals.map(referral => (
                <ReferredUserItem key={referral.referredUserMobile} referral={referral} />
              ))
            ) : (
              <p>No referrals made yet. Invite a friend today!</p>
            )}
          </ul>
        </div>
      );
    }}
  </Query>
);

export default ReferredUserList;

const GET_REFERRED_USERS = gql`
  {
    currentUser {
      id
      referrals {
        referredUserName
        referredUserMobile
        referralStatus
        referredUserNameTemp
        hoursDriven
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Referral/ReferredUserList.js